module.exports = __webpack_public_path__ + "static/media/project-summary.2d6fad60.scss";


//////////////////
// WEBPACK FOOTER
// ./src/sass/project-summary.scss
// module id = 2294
// module chunks = 0